import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import type { SalesChannel } from '@/types/integration';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'query' | 'limit'>;

export const getSalesChannels = async (
  scope: RequestScope,
  params: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<SalesChannel[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<SalesChannel[]>>('/sales_channel', { ...options, params });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
